export default __webpack_public_path__ + "static/media/Bread.f7eb1dc9.png";